// RecentCompletionsPreview.tsx

import { z } from "zod";
import { ApiSurveyRecentCompletionsResSchema } from "@bridge-applications/eh-types";
import "./RecentCompletionsPreview.scss";
import { walletToGradient } from "../../../../../../../logic/helpers/walletToGradient";
import { useTranslation } from "react-i18next";

interface RecentCompletionsPreviewProps {
    recentCompletions: z.infer<
        typeof ApiSurveyRecentCompletionsResSchema
    >["recentCompletions"];
    totalCompletionsCount: number;
}

export default function RecentCompletionsPreview({
    recentCompletions,
    totalCompletionsCount,
}: RecentCompletionsPreviewProps) {
    const { t } = useTranslation();
    const getShortWallet = (wallet: string | null) => {
        if (!wallet) return "Unknown wallet";
        return wallet.slice(0, 4) + "..." + wallet.slice(-4);
    };

    return (
        <div className="recent-completions-preview">
            <h3 className="recent-completions-preview__title">
                {t("TaskOverviewSurvey.XmostRecentRespondents", { num: 5 })}
            </h3>

            <div className="recent-completions-preview__items">
                {recentCompletions.map((completion) => {
                    const [topLeft, bottomRight] = walletToGradient(
                        completion.walletAddress,
                    );

                    return (
                        <div
                            className="recent-completions-preview__item"
                            key={completion.walletAddress}
                        >
                            <div
                                className="recent-completions-preview__item__avatar"
                                style={{
                                    background: `linear-gradient(135deg, ${topLeft} 0%, ${bottomRight} 100%)`,
                                }}
                            >
                                <p className="recent-completions-preview__item__avatar__letter">
                                    {completion.username
                                        ?.slice(0, 1)
                                        .toUpperCase()}
                                </p>
                            </div>

                            <div className="recent-completions-preview__item__text">
                                <p className="recent-completions-preview__item__username">
                                    {completion.username === null ||
                                    completion.username === "" ||
                                    completion.username === "UNKNOWN_USERNAME"
                                        ? "-"
                                        : `@${completion.username}`}
                                </p>
                                <p className="recent-completions-preview__item__wallet">
                                    {getShortWallet(completion.walletAddress)}
                                </p>
                            </div>
                        </div>
                    );
                })}
            </div>

            {totalCompletionsCount > 5 && (
                <p className="recent-completions-preview__more">
                    {t("TaskOverviewSurvey.Xmore", {
                        num: totalCompletionsCount - 5,
                    })}
                </p>
            )}
        </div>
    );
}
